import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { GeneralState } from './types';

type GeneralGetterTree = GetterTree<GeneralState, RootState>;

export const getters: GeneralGetterTree = {
    getConfigDebug(state: GeneralState): boolean {
        if (state.config){
            return state.config["DEBUG"] == "T" ? true : false;
            //return state.config.filter(x=>x.AT_MODULO == "General" && x.AT_NOMBRE == "DEBUG")[0].AT_VALOR == "T" ? true : false;
        } else return false;
    },
    getConfigMenu(state: GeneralState): boolean {
        if (state.config){
            return state.config["MENU"] == "T" ? true : false;
            //return state.config.filter(x=>x.AT_MODULO == "General" && x.AT_NOMBRE == "MENU")[0].AT_VALOR == "T" ? true : false;
        } else return false;
    },
};
